import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin, setToken } from "./adminApi";

export const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { token } = await adminLogin(email.trim(), password);
      setToken(token);
      navigate("/admin/trips");
    } catch (err) {
      setError(err.message === "Unauthorized" ? "Invalid email or password" : err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink px-6" data-testid="admin-login">
      <form onSubmit={submit} className="w-full max-w-sm">
        <p className="font-sans text-xs uppercase tracking-[0.3em] text-teal">Holideviser</p>
        <h1 className="mt-4 font-serif text-4xl font-light text-cream">Admin.</h1>
        <p className="mt-3 font-sans text-sm text-sand">Private trip-request management.</p>

        <label className="mt-10 block font-sans text-xs uppercase tracking-[0.2em] text-sand">Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="admin-email"
          className="mt-2 w-full rounded-none border border-charcoal bg-charcoal/30 px-4 py-3 font-sans text-cream focus:border-teal focus:outline-none"
        />
        <label className="mt-6 block font-sans text-xs uppercase tracking-[0.2em] text-sand">Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          data-testid="admin-password"
          className="mt-2 w-full rounded-none border border-charcoal bg-charcoal/30 px-4 py-3 font-sans text-cream focus:border-teal focus:outline-none"
        />
        {error && <p className="mt-4 font-sans text-sm text-teal" data-testid="admin-login-error">{error}</p>}
        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit"
          className="mt-8 w-full rounded-none bg-teal px-6 py-3 font-sans text-sm uppercase tracking-[0.18em] text-ink transition-colors hover:bg-cream disabled:opacity-60"
        >
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
};
